// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	$('.form-select').select2({});
	$('#archives-dropdown-2').select2({});

	// On Scroll Trigger & Menu Triggers
	function updateMenuState() {
		const anyMenuActive = $('.programme-menu').hasClass('active') || $('.treatments-menu').hasClass('active') || $('.weight-menu').hasClass('active');
		const scrollTop = $(window).scrollTop();

		// Update menuOpen state globally
		menuOpen = anyMenuActive;

		// Handle scroll-active class only when no menu is open
		if (!menuOpen) {
			if (scrollTop > 50) {
				$('.wrapper-navbar').addClass('scroll-active');
			} else {
				$('.wrapper-navbar').removeClass('scroll-active');
			}
		}
	}

	let menuOpen = false;

	$(window).on('load', function () {
		updateMenuState();
	});

	$(window).on('scroll', function () {
		updateMenuState();
	});

	function toggleMenu(menuSelector, triggerSelector) {
		const wasActive = $(menuSelector).hasClass('active');

		// Close all menus
		$('.desktop-expand, .programme-menu, .treatments-menu, .weight-menu').removeClass('active');
		$('.programme-trigger, .treatments-trigger').removeClass('active');

		if (!wasActive) {
			// Open the selected menu
			$(menuSelector).addClass('active');
			$(triggerSelector).addClass('active');
			$('.desktop-expand').addClass('active');
		}

		// Update menu-active class
		const anyMenuActive = $('.programme-menu').hasClass('active') || $('.treatments-menu').hasClass('active') || $('.weight-menu').hasClass('active');
		if (anyMenuActive) {
			$('.wrapper-navbar').addClass('menu-active');
		} else {
			$('.wrapper-navbar').removeClass('menu-active');
		}

		updateMenuState(); // Ensure scroll-active respects the current menu state
	}

	// Menu triggers
	$('.programme-trigger').on('click', function (e) {
		e.preventDefault();
		toggleMenu('.programme-menu', '.programme-trigger');
	});

	$('.treatments-trigger').on('click', function (e) {
		e.preventDefault();
		toggleMenu('.treatments-menu', '.treatments-trigger');
	});

	$('.weight-trigger').on('click', function (e) {
		e.preventDefault();
		toggleMenu('.weight-menu', '.weight-trigger');
	});


	$('.ck-burger').on('click', function () {
		$(this).addClass('hidden');
		$('.ck-close').addClass('active');
		$('.wrapper-navbar').addClass('active menu-active');
		$('.mobile-expand').addClass('active');
		$('body').css('overflow', 'hidden');
	});

	$('.ck-close').on('click', function () {
		$('.ck-burger').removeClass('hidden');
		$(this).removeClass('active');
		$('.wrapper-navbar').removeClass('active menu-active');
		$('.mobile-expand').removeClass('active');
		$('body').css('overflow', '');
	});


	$('.accordion-item').on('click', function(e) {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).find('i.fa-solid').removeClass('fa-minus').addClass('fa-plus');
		} else {
			$('.accordion-item').removeClass('active').find('i.fa-solid').removeClass('fa-minus').addClass('fa-plus');
			$(this).addClass('active');
			$(this).find('i.fa-solid').removeClass('fa-plus').addClass('fa-minus');
		}
	});

	const baseCount = 6;
	const baseSpeed = 10000;

	const $slider = $('.vertical-slider');
	const slideCount = $slider.children().length;

	const dynamicSpeed = (slideCount / baseCount) * baseSpeed;

	$slider.slick({
		vertical: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		verticalSwiping: true,
		dots: false,
		arrows: true,
		prevArrow: '.custom-ba-prev-arrow',
		nextArrow: '.custom-ba-next-arrow',
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: dynamicSpeed,
		cssEase: 'linear',
		pauseOnFocus: false,
		pauseOnHover: false,
	});

	$('.vertical-slider-mob').slick({
		vertical: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		verticalSwiping: true,
		dots: false,
		arrows: true,
		prevArrow: '.custom-ba-prev-arrow-mob',
		nextArrow: '.custom-ba-next-arrow-mob',
		infinite: true,
	});

	$('.featured-article-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		adaptiveHeight: true,
		prevArrow: '.custom-fa-prev-arrow',
		nextArrow: '.custom-fa-next-arrow',
		arrows: true,
		variableWidth: true,
	});


	if ($('.timeline-slider').length) {
		$('.timeline-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			infinite: false,
			speed: 500,
			prevArrow: '.custom-rt-prev-arrow',
			nextArrow: '.custom-rt-next-arrow',
			arrows: true,
		});

		// Listen for clicks on SVG groups like <g id="month-5">
		$(document).on('click', 'g[id^="month-"]', function(e) {
			e.preventDefault();

			var id = $(this).attr('id'); // e.g., "month-5"
			var match = id.match(/^month-(\d+)$/);

			if (match) {
				var monthNum = parseInt(match[1], 10);
				$('.timeline-slider').slick('slickGoTo', monthNum - 1);
			}
		});
	}

	$('.case-gallery-slider').each(function() {
		var $slider = $(this);
		var sliderClass = $slider.attr('class').split(' ').filter(function(cls) {
			return cls.startsWith('slider-');
		})[0]; // find the dynamic class e.g. slider-1, slider-2 etc.

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			infinite: true,
			speed: 500,
			prevArrow: $('.custom-cgs-prev-arrow[data-slider="' + sliderClass + '"]'),
			nextArrow: $('.custom-cgs-next-arrow[data-slider="' + sliderClass + '"]'),
			arrows: true,
			fade: true,
			cssEase: 'linear',
			adaptiveHeight: true,
		});
	});

	$('.slider-cases').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		dots: false,
		prevArrow: '.custom-pc-prev-arrow',
		nextArrow: '.custom-pc-next-arrow',
		arrows: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$(".scroll-smooth").on("click", function (e) {
		e.preventDefault();

		var target = $(this).attr("href");

		if (target.startsWith("#") && $(target).length) {
			$("html, body").animate(
				{
					scrollTop: $(target).offset().top - 50,
				},
				800
			);
		}
	});

	$('.count').each(function () {
		$(this).prop('Counter',0).animate({
			Counter: $(this).text()
		}, {
			duration: 2500,
			easing: 'swing',
			step: function (now) {
				$(this).text(Math.ceil(now));
			}
		});
	});

	// Delegate click for Metric
	$(document).on('click', '.selector .metric', function () {
		$('.selector .metric').addClass('active');
		$('.selector .imperial').removeClass('active');

		$('.form-metric').addClass('active');
		$('.form-imperial').removeClass('active');
	});

	// Delegate click for Imperial
	$(document).on('click', '.selector .imperial', function () {
		$('.selector .imperial').addClass('active');
		$('.selector .metric').removeClass('active');

		$('.form-imperial').addClass('active');
		$('.form-metric').removeClass('active');
	});

	$('.footer-logo-slider').slick({
		slidesToShow: 7,
		slidesToScroll: 1,
		variableWidth: true,
		verticalSwiping: false,
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		centerMode: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
		]
	});

	$('.bmi-calc .selector .imperial').on('click', function () {
		$('.bmi-calc .form-metric').addClass('active');
		$('.bmi-calc .form-imperial').removeClass('active');
	});

	$('.bmi-calc .selector .metric').on('click', function () {
		$('.bmi-calc .form-imperial').removeClass('active');
		$('.bmi-calc .form-metric').addClass('active');
	});

	function equalisePostTitle() {
		var maxHeight = 0;
		var $els = $('.post-title-h2');

		$els.css('height', 'auto');

		$els.each(function () {
			var elHeight = $(this).height();
			if (elHeight > maxHeight) {
				maxHeight = elHeight;
			}
		});

		$els.height(maxHeight);
	}

	equalisePostTitle();
	$(window).on('resize', equalisePostTitle);

// 	// Video Model
// 	// Background Vimeo player
// 	let bgVimeoIframe = document.getElementById('bg-vimeo-video');
// 	let bgPlayer;
//
// 	if (bgVimeoIframe) {
// 		bgPlayer = new Vimeo.Player(bgVimeoIframe);
// 	}
//
// 	const modal = document.getElementById("video-modal");
// 	const iframe = document.getElementById("video-modal-iframe");
// 	const closeBtn = document.getElementById("video-modal-close");
//
// 	document.querySelectorAll(".custom-play-overlay").forEach(overlay => {
// 		overlay.addEventListener("click", function () {
// 			const videoType = this.dataset.videoType;
// 			const videoId = this.dataset.videoId;
//
// 			let url = "";
// 			if (videoType === "youtube") {
// 				url = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1`;
// 			}
// 			if (videoType === "vimeo") {
// 				url = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=0`;
// 			}
//
// 			iframe.src = url;           // modal video
// 			modal.style.display = "flex";
//
// 			// Pause background Vimeo while modal is open
// 			if (bgPlayer && videoType === "vimeo") {
// 				bgPlayer.pause();
// 			}
// 		});
// 	});
//
// 	// Close modal
// 	closeBtn.addEventListener("click", function () {
// 		modal.style.display = "none";
// 		iframe.src = ""; // stop modal video
//
// 		// Resume background video
// 		if (bgPlayer) {
// 			bgPlayer.play();
// 		}
// 	});
//
// 	// Close modal by clicking outside
// 	modal.addEventListener("click", function (e) {
// 		if (e.target === modal) {
// 			modal.style.display = "none";
// 			iframe.src = "";
// 			if (bgPlayer) {
// 				bgPlayer.play();
// 			}
// 		}
// 	});



	// =============================
	// BACKGROUND VIMEO PLAYER
	// =============================
	let bgPlayers = [];

	document.querySelectorAll('.popout-video[src*="vimeo"]').forEach(iframe => {
		bgPlayers.push(new Vimeo.Player(iframe));
	});


	// =============================
	// OPEN MODAL
	// =============================
	document.querySelectorAll(".custom-play-overlay").forEach(btn => {

		btn.addEventListener("click", function () {

			const modalId = this.dataset.modal;
			const type = this.dataset.type;
			const id = this.dataset.id;

			const modal = document.getElementById(modalId);
			const iframe = modal.querySelector(".modal-iframe");

			// Show modal first
			modal.style.display = "flex";

			// Pause background videos
			bgPlayers.forEach(player => player.pause());

			if (type === "youtube") {
				// YouTube autoplay + unmute
				iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=0&controls=1`;
			}

			if (type === "vimeo") {
				// Start muted (autoplay allowed)
				iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1&muted=1`;

				const player = new Vimeo.Player(iframe);

				// Since the user clicked the overlay, we can unmute immediately
				player.setVolume(1).then(() => {
					console.log("Vimeo unmuted");
				}).catch(() => {
					console.log("Autoplay with sound blocked by Chrome, will require click to unmute");
					// Optional fallback: listen for first user click
					modal.addEventListener("click", function unmuteOnClick() {
						player.setVolume(1);
						modal.removeEventListener("click", unmuteOnClick);
					});
				});
			}

		});

	});



	$('.treatment-steps-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		speed: 4000,
		pauseOnHover: true,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});


	// =============================
	// CLOSE MODALS
	// =============================
	document.querySelectorAll(".modal-close").forEach(closeBtn => {

		closeBtn.addEventListener("click", function () {

			const modal = this.closest(".video-modal");
			const iframe = modal.querySelector(".modal-iframe");

			modal.style.display = "none";
			iframe.src = "";

			// Resume background videos
			bgPlayers.forEach(player => player.play());

		});

	});


	// =============================
	// CLOSE ON BACKDROP CLICK
	// =============================
	document.querySelectorAll(".video-modal").forEach(modal => {

		modal.addEventListener("click", function (e) {

			if (e.target === modal) {

				const iframe = modal.querySelector(".modal-iframe");

				modal.style.display = "none";
				iframe.src = "";

				bgPlayers.forEach(player => player.play());
			}

		});

	});


	// === Universal Equal Height Function ===
	function setEqualHeights(wrapperSelector) {
		$(wrapperSelector).find('.split-section-row').each(function() {
			var $row = $(this);
			var $text = $row.find('.text-content');
			var $image = $row.find('.image-content');
			var $line = $row.find('.line-container');

			// Reset heights first
			$image.css('height', 'auto');
			$line.css('height', 'auto');

			// Get text-content height
			var textHeight = $text.outerHeight();

			// Apply same height to image and line
			$image.css('height', textHeight + 'px');
			$line.css('height', textHeight + 'px');
		});
	}

	// === Universal Dot Position Function ===
	function updateDotPosition(wrapperSelector) {
		$(wrapperSelector).each(function() {
			var $wrapper = $(this);
			var $line = $wrapper.find('.inner-line');
			var $dot = $wrapper.find('.inner-dot');

			if (!$line.length || !$dot.length) return;

			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var wrapperTop = $wrapper.offset().top;
			var wrapperHeight = $wrapper.outerHeight();

			var lineHeight = $line.height();
			var dotHeight = $dot.outerHeight();

			var bottomOffsetPx = (dotHeight / 2) - 12;
			var maxTop = Math.max(0, lineHeight - dotHeight - bottomOffsetPx);

			// Center the dot slightly higher (e.g., 100px above middle)
			var offset = -75;
			var progress = (scrollTop + windowHeight / 2 + offset - wrapperTop) / wrapperHeight;
			progress = Math.min(Math.max(progress, 0), 1);

			var topPosition = Math.round(progress * maxTop);
			$dot.css('top', topPosition + 'px');
		});
	}

	// === Run for both sections independently ===
	setEqualHeights('.alternating-scroller-section');
	updateDotPosition('.alternating-scroller-section');

	// === Bind resize & scroll events ===
	$(window).on('resize', function() {
		setEqualHeights('.alternating-scroller-section');
	});

	$(window).on('scroll resize', function() {
		updateDotPosition('.alternating-scroller-section');
	});


});



!function(){var a=function(a,b){var c=document.createElement("canvas");"undefined"!=typeof G_vmlCanvasManager&&G_vmlCanvasManager.initElement(c);var d=c.getContext("2d");if(c.width=c.height=b.size,a.appendChild(c),window.devicePixelRatio>1){var e=window.devicePixelRatio;c.style.width=c.style.height=[b.size,"px"].join(""),c.width=c.height=b.size*e,d.scale(e,e)}d.translate(b.size/2,b.size/2),d.rotate((-0.5+b.rotate/180)*Math.PI);var f=(b.size-b.lineWidth)/2;b.scaleColor&&b.scaleLength&&(f-=b.scaleLength+2);var g=function(a,b,c){c=Math.min(Math.max(0,c||1),1),d.beginPath(),d.arc(0,0,f,0,2*Math.PI*c,!1),d.strokeStyle=a,d.lineWidth=b,d.stroke()},h=function(){var a,c,e=24;d.lineWidth=1,d.fillStyle=b.scaleColor,d.save();for(var e=24;e>=0;--e)0===e%6?(c=b.scaleLength,a=0):(c=.6*b.scaleLength,a=b.scaleLength-c),d.fillRect(-b.size/2+a,0,c,1),d.rotate(Math.PI/12);d.restore()};Date.now=Date.now||function(){return+new Date};var i=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){window.setTimeout(a,1e3/60)}}();this.clear=function(){d.clearRect(b.size/-2,b.size/-2,b.size,b.size)},this.draw=function(a){this.clear(),b.scaleColor&&h(),b.trackColor&&g(b.trackColor,b.lineWidth),d.lineCap=b.lineCap;var c;c="function"==typeof b.barColor?b.barColor(a):b.barColor,a>0&&g(c,b.lineWidth,a/100)}.bind(this),this.animate=function(a,c){var d=Date.now();b.onStart(a,c);var e=function(){var f=Math.min(Date.now()-d,b.animate),g=b.easing(this,f,a,c-a,b.animate);this.draw(g),b.onStep(a,c,g),f>=b.animate?b.onStop(a,c):i(e)}.bind(this);i(e)}.bind(this)},b=function(b,c){var d,e={barColor:"#ef1e25",trackColor:"#f9f9f9",scaleColor:"#dfe0e0",scaleLength:5,lineCap:"round",lineWidth:3,size:110,rotate:0,animate:1e3,renderer:a,easing:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b+c:-d/2*(--b*(b-2)-1)+c},onStart:function(){},onStep:function(){},onStop:function(){}},f={},g=0,h=function(){this.el=b,this.options=f;for(var a in e)e.hasOwnProperty(a)&&(f[a]=c&&"undefined"!=typeof c[a]?c[a]:e[a],"function"==typeof f[a]&&(f[a]=f[a].bind(this)));f.easing="string"==typeof f.easing&&"undefined"!=typeof jQuery&&jQuery.isFunction(jQuery.easing[f.easing])?jQuery.easing[f.easing]:e.easing,d=new f.renderer(b,f),d.draw(g),b.dataset&&b.dataset.percent&&this.update(parseInt(b.dataset.percent,10))}.bind(this);this.update=function(a){return a=parseInt(a,10),f.animate?d.animate(g,a):d.draw(a),g=a,this}.bind(this),h()};window.EasyPieChart=b}();

var chartSize = document.querySelector('.increasing-rates-chart .item').offsetWidth; // Get the width of the closest item

var options = {
	scaleColor: false,
	trackColor: '#fff',
	barColor: '#f9a003',
	lineWidth: 30,
	lineCap: 'left',
	size: chartSize // Initially set the chart size
};

var charts = []; // Array to store chart instances

function initializeCharts() {
	// Remove only previous canvas elements without affecting <p> tags
	[].forEach.call(document.querySelectorAll('.increasing-rates-chart .chart'), function(el) {
		var canvas = el.querySelector('canvas');
		if (canvas) {
			el.removeChild(canvas); // Remove the existing canvas if it exists
		}
	});

	charts = []; // Reset the charts array

	// Initialize new charts with the updated size
	[].forEach.call(document.querySelectorAll('.increasing-rates-chart .chart'), function(el) {
		charts.push(new EasyPieChart(el, options));
	});
}

function handleIntersection(entries, observer) {
	entries.forEach(function(entry) {
		if (entry.isIntersecting) {
			// If the .increasing-rates-chart is in view, initialize the charts
			initializeCharts();
			// Stop observing once the charts are initialized
			observer.unobserve(entry.target);
		}
	});
}

// Set up the IntersectionObserver
var observerOptions = {
	root: null, // Use the viewport as the root
	rootMargin: '0px',
	threshold: 0.05 // Trigger when 10% of the element is visible
};

var observer = new IntersectionObserver(handleIntersection, observerOptions);

// Observe the .increasing-rates-chart element
var healthcareBlock = document.querySelector('.increasing-rates-chart');
if (healthcareBlock) {
	observer.observe(healthcareBlock);
}

// Ensure charts are resized and reinitialized on window resize
window.addEventListener('resize', function() {
	chartSize = document.querySelector('.increasing-rates-chart .item').offsetWidth;
	options.size = chartSize; // Update the size in the options object
	initializeCharts(); // Reinitialize charts with updated size
});

document.addEventListener("DOMContentLoaded", function () {
	const columns = document.querySelectorAll('.equal-height-column');
	let maxHeight = 0;

	columns.forEach(col => {
		col.style.height = 'auto'; // Reset
		if (col.offsetHeight > maxHeight) {
			maxHeight = col.offsetHeight;
		}
	});

	columns.forEach(col => {
		col.style.height = maxHeight + 'px';
	});
});
